import { LDProvider } from "launchdarkly-react-client-sdk";
import React from "react";

//
// @todo this is duplicated in CMS and bonfire; need to consolidate
// useAnalytics.tsx into common-app
//
const anonymousUserGUID = "26503692-2fd6-4cd5-b66b-953c42f72a3b";

const FeatureFlagProvider: React.FC<React.PropsWithChildren<unknown>> = (
  props,
) => {
  if (!process.env.REACT_APP_LD_CLIENT_ID) {
    return <>{props.children}</>;
  }

  return (
    <LDProvider
      clientSideID={process.env.REACT_APP_LD_CLIENT_ID}
      context={{
        kind: "user",
        key: anonymousUserGUID,
      }}
    >
      {props.children}
    </LDProvider>
  );
};

export default FeatureFlagProvider;
